import { LoadingBackdrop } from '../../Feedback/LoadingBackdrop';
import type { LoadingBackdropProps } from '../../Feedback/LoadingBackdrop';

/**
 * Props for the LoadingScreen component.
 * Optional overrides forwarded to LoadingBackdrop; when omitted, defaults
 * are used (open, spinnerColor 'inherit'). Pass data-testid from the consumer if needed.
 *
 * @see LoadingBackdropProps for full prop definitions (open, spinnerColor,
 * showSpinner, spinnerSize, sx, data-testid, etc.).
 */
export type LoadingScreenProps = Partial<
  Pick<LoadingBackdropProps, 'spinnerColor' | 'showSpinner' | 'spinnerSize' | 'sx' | 'data-testid'>
>;

/**
 * Full-screen loading screen for route-level or app-level loading states.
 * Renders a blocking backdrop with a circular progress spinner. Props are
 * forwarded to LoadingBackdrop; when not provided, defaults ensure a visible
 * full-screen loader (open, spinnerColor 'inherit').
 *
 * Use as a fallback for Suspense or while data is loading.
 *
 * @example
 * <Suspense fallback={<LoadingScreen />}>
 *   <LazyComponent />
 * </Suspense>
 * @example
 * <LoadingScreen spinnerColor="primary" data-testid="app-loading" />
 */
export function LoadingScreen(props: LoadingScreenProps) {
  return <LoadingBackdrop open spinnerColor="inherit" {...props} />;
}
